import { render, staticRenderFns } from "./DepartmentPreview.vue?vue&type=template&id=53efea62&scoped=true&"
import script from "./DepartmentPreview.vue?vue&type=script&lang=js&"
export * from "./DepartmentPreview.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentPreview.vue?vue&type=style&index=0&id=53efea62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53efea62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDialog,VImg,VRow})
